import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { ListComponent } from "../list-component/list-component";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { ListItem, ModalListItemI } from '../../model';
import { MatButton } from '@angular/material/button';


@Component({
  selector: 'app-list-modal-component',
  imports: [
    ListComponent,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    MatButton
  ],
  templateUrl: './list-modal-component.html',
  styleUrl: './list-modal-component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListModalComponent {
  readonly dialogRef = inject(MatDialogRef<ListModalComponent>);

  // recupere les donnees envoyes par le parent
  readonly inputData = inject<ModalListItemI>(MAT_DIALOG_DATA);

  returnValue : ListItem = {id : '', name : ''}

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
  }


  getIdItemList(values : ListItem[]){
    this.returnValue = values[0]
    this.dialogRef.close(values[0])
  }

  close(){
    this.dialogRef.close(this.returnValue)
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.close()
  }
}
